<template>
  <div>
    <div>
      <v-btn v-if="!viewOnly" small text @click="cancel"
        ><v-icon small color="primary">mdi-keyboard-backspace</v-icon> Back
      </v-btn>
      <v-card v-if="Boolean(districtAdminId)" class="grey lighten-4" flat>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon x-large> mdi-account-circle </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{
              form.firstName + " " + form.lastName
            }}</v-list-item-title>
            <v-list-item-subtitle
              >Email: {{ form.emailAddress }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </div>
    <validation-observer ref="form" v-slot="{ invalid }">
      <v-card flat>
        <v-row v-if="isAdmin && Boolean(districtAdminId) && !viewOnly">
          <v-spacer></v-spacer>
          <v-switch
            v-model="editMode"
            label="Edit Mode"
            dense
            class="mx-4"
          ></v-switch>
        </v-row>
        <v-expansion-panels v-model="panels" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="text-h6"
                ><v-icon left>mdi-account-outline</v-icon> Profile</span
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="form.legacyProviderId"
                    label="Legacy Id"
                    readonly
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <validation-provider rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="form.firstName"
                      label="First Name"
                      :readonly="!editMode"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="4">
                  <validation-provider rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="form.lastName"
                      label="Last Name"
                      :readonly="!editMode"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="form.title"
                    :items="titles"
                    label="Title"
                    :readonly="!editMode"
                  ></v-select>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="text-h6"
                ><v-icon left>mdi-map-marker-outline</v-icon> Address</span
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="form.streetAddress"
                    label="Street Address"
                    :readonly="!editMode"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="form.streetAddressLine2"
                    label="Street Address Line 2"
                    :readonly="!editMode"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="form.city"
                    label="City"
                    :readonly="!editMode"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-select
                    :items="usStates"
                    v-model="form.state"
                    label="State"
                    :readonly="!editMode"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="1">
                  <v-text-field
                    v-model="form.zipCode"
                    label="ZipCode"
                    :readonly="!editMode"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="text-h6"
                ><v-icon left>mdi-phone-outline</v-icon> Contact</span
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="form.emailAddress"
                    label="Email Address"
                    :readonly="!editMode"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="form.phone"
                    label="Phone"
                    v-mask="maskPhone"
                    :readonly="!editMode"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="form.fax"
                    label="Fax"
                    v-mask="maskPhone"
                    :readonly="!editMode"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card-actions v-if="isAdmin && !viewOnly">
          <v-spacer></v-spacer>
          <v-btn @click="cancel" text>Cancel</v-btn>
          <v-btn @click="save" :disabled="invalid || !editMode" color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </validation-observer>
  </div>
</template>

<script>
import DistrictAdmin from "../../../objs/DistrictAdmin";
import { clearPhoneNumberFormat } from "../../../utils/format-utils";
export default {
  props: ["districtAdminId", "viewOnly"],
  data() {
    return {
      form: new DistrictAdmin(),
      editMode: !Boolean(this.districtAdminId), // default to true on create
      maskPhone: "(###) ###-####",
      panels: [0], // expand Profile panel
    };
  },
  mounted() {
    if (this.districtAdminId) {
      this.form = this.$store.getters["optionsModule/getDistrictAdminById"](
        this.districtAdminId
      );
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
    usStates() {
      return this.$store.state.optionsModule.usStates;
    },
    titles() {
      return this.$store.state.optionsModule.titles;
    },
  },
  methods: {
    cancel() {
      this.$router.push({ name: "DistrictAdmins" });
    },
    async save() {
      this.$store.commit("uxModule/setShowLoader", true);
      this.form.phone = clearPhoneNumberFormat(this.form.phone);
      this.form.fax = clearPhoneNumberFormat(this.form.fax);
      var message;
      if (this.districtAdminId) {
        message = await this.$store.dispatch(
          "optionsModule/updateDistrictAdmin",
          this.form
        );
      } else {
        message = await this.$store.dispatch(
          "optionsModule/createDistrictAdmin",
          this.form
        );
      }
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "District Admin saved successfully"
        );
      }
      this.$store.commit("uxModule/setShowSnackbar", true);
      this.$store.commit("uxModule/setShowLoader", false);
      this.$router.push({ name: "DistrictAdmins" });
    },
  },
};
</script>